module.exports = __webpack_public_path__ + "img/15.353c9b7a.png";